import React from 'react';
import createDebug from 'debug';
import { RouteComponentProps, RouteProps, Route } from 'react-router';
import { AuthenticatedState } from 'core/data/authenticated';

const debug = createDebug('evp:authenticated-route');

interface Props extends RouteProps {
  auth: AuthenticatedState;
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
}

type RenderComponent = (props: RouteComponentProps<any>) => React.ReactNode;

export default function AuthenticatedRoute({
  component: Component,
  auth,
  ...rest
}: Props): JSX.Element | null {
  debug('authenticated state `%s`', auth);

  if (auth === 'unknown') return null;

  const renderComponent: RenderComponent = props => <Component {...props} />;
  return <Route {...rest} render={renderComponent} />;
}
